































































import Vue from 'vue'
import Component from 'vue-class-component'
import Spinner from '@/components/Spinner.vue'
import FormDateTimeField from "@/components/FormDateTimeField.vue"
import appManager from '@/services/AppManager'
import * as api from '@/services/ApiService'
import { ApiEventTypeCountData, CompanyJobCountData } from "@/core/ApiTypes"
import { ApiKeyMode, Company } from "@/core/Types"
import { convertDateLocalToUtc, convertDateUtcToLocal, MILLIS_PER_DAY } from "@/core/DateUtils"

@Component({
    components: {
        Spinner,
        FormDateTimeField
    }
})
export default class ApiEventsView extends Vue {
    startTimeMillis: number = 0
    endTimeMillis: number = 0
    modeDevOrProdIndex: number = 1
    isLoading = true
    companyJobCountHeaders = [
        { text: 'Company', value: 'companyId', align: 'start' },
        { text: 'Jobs', value: 'jobCount', align: 'end' },
        { text: 'Events', value: 'eventCount', align: 'end' },
    ]
    companyJobCounts: CompanyJobCountData[] = []
    eventTypeCountHeaders = [
        { text: 'Type', value: 'type', align: 'start' },
        { text: 'Count', value: 'eventCount', align: 'end' },
    ]
    eventTypeCounts: ApiEventTypeCountData[] = []
    queryDurationMillis: number = -1
    companyMap = new Map<string, Company>()
    companyMapCounter = 0       // simple way to force update when loading new company

    // noinspection JSUnusedGlobalSymbols
    async created() {
        const nowUtc = Date.now()
        const nowLocal = convertDateUtcToLocal(new Date(nowUtc)).getTime()
        const startOfTodayLocal = nowLocal - (nowLocal % MILLIS_PER_DAY)
        const startOfTodayUtc = convertDateLocalToUtc(new Date(startOfTodayLocal)).getTime()
        this.startTimeMillis = startOfTodayUtc
        this.endTimeMillis = startOfTodayUtc + MILLIS_PER_DAY

        await this.updateCompanyJobCounts()
    }

    private async onDateRangeChanged() {
        console.log(`Date Range: ${new Date(this.startTimeMillis).toISOString()} - ${new Date(this.endTimeMillis).toISOString()}`)
        await this.updateCompanyJobCounts()
    }

    private async onApiKeyModeChanged() {
        console.log(`API Key Mode: ${this.modeDevOrProdIndex}`)
        await this.updateCompanyJobCounts()
    }

    // noinspection JSMethodCanBeStatic
    private createCompanyJobCountKey(item: CompanyJobCountData) {
        return `${this.companyMapCounter} - ${item.companyId} - ${item.jobCount}`
    }

    private onCompanyJobCountClicked(item: CompanyJobCountData) {
        console.log(item.companyId)
    }

    private async updateCompanyJobCounts() {
        this.isLoading = true
        this.companyJobCounts = []

        try {
            const queryStartTime = Date.now()
            const response = await api.queryApiEventJobCounts({
                apiKeyMode: (this.modeDevOrProdIndex === 0) ? ApiKeyMode.DEV : ApiKeyMode.PROD,
                createdMillisGreaterThanOrEqualTo: this.startTimeMillis,
                createdMillisLessThan: this.endTimeMillis,
            })
            const queryEndTime = Date.now()
            this.queryDurationMillis = queryEndTime - queryStartTime
            this.companyJobCounts = response.companyJobCounts
            this.companyJobCounts.sort((d1, d2) => d2.jobCount - d1.jobCount)
            this.eventTypeCounts = response.eventTypeCounts
            this.eventTypeCounts.sort((e1, e2) => e2.eventCount - e1.eventCount)

            // load any new companies in the local cache
            for (const data of this.companyJobCounts) {
                const companyId = data.companyId
                if (!this.companyMap.has(companyId)) {
                    appManager.companyManager.getCompany(companyId)
                        .then(company => {
                            if (company) {
                                this.companyMap.set(companyId, company)
                                this.companyMapCounter++
                            }
                        })
                }
            }
        } catch (error) {
            appManager.alertManager.publishError(`Error Loading: ${error}`)
        }
        this.isLoading = false
    }

    private isLoadingCompany(companyId: string): boolean {
        return !this.companyMap.has(companyId)
    }

    private getCompanyName(companyId: string): string {
        const company = this.companyMap.get(companyId)
        return company?.data?.name || ''
    }
}
